<template>
    <div class="stat-summary">
      <h3>{{ $t('randevu.stats.status.title') }}</h3>
      <div v-if="stats" class="status-list">
        <div class="status-item">
          <span>{{ $t('randevu.stats.status.pending') }}</span>
          <strong>{{ stats.pending }}</strong>
        </div>
        <div class="status-item">
          <span>{{ $t('randevu.stats.status.confirmed') }}</span>
          <strong>{{ stats.confirmed }}</strong>
        </div>
        <div class="status-item">
          <span>{{ $t('randevu.stats.status.completed') }}</span>
          <strong>{{ stats.completed }}</strong>
        </div>
        <div class="status-item">
          <span>{{ $t('randevu.stats.status.cancelled') }}</span>
          <strong>{{ stats.cancelled }}</strong>
        </div>
      </div>
      <p v-else>{{ $t('common.loading') }}</p>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    name: 'AppointmentStatusSummary',
    data() { return { stats: null }; },
    async created() {
      try {
        const { data } = await axios.get('/promo/user/stats/status-counts');
        this.stats = data;
      } catch (err) { console.error('Veri alınamadı:', err); }
    }
  };
  </script>
  
  <style scoped>
  .stat-summary {
    padding: 1rem;
    background-color: #050505; 
    border-radius: 6px;
    margin-top: 1em;
  }
  
  h3 {
    margin-bottom: 0.5rem;
    font-size: 1rem; 
    font-weight: 400;
  }
  .status-list {
    display: flex;
    flex-direction: column;
  }
  
  .status-item {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    border-bottom: 1px solid #023032;
  }
    
  </style>
  